import axios from 'axios';
import router from '@/router';
import { Message } from 'element-ui';

const API = {
    ADMIN: "/admin",
    PERMISSION: "/permission",
    ROLE: "/role",
    USER: "/user",
    PRODUCT: "/product",
    ORDER: "/order",
    BANNER: "/banner",
    VIDEO: "/video",
    TYPE: "/type",
    ARTICLE: "/article",
    COURSE: "/course",
    COURSE_RECORD: "/courseRecord",
    ORDER_COURSE: "/order/course",
    ORDER_RECORD: "/order/record",
    FAVOURITE: {
        ARTICLE: "/favourite/article",
        PRODUCT: "/favourite/product",
    },
    NOTIFY: "/notify",
    TREE: {
        PERMISSION: "/permission/tree"
    },
    ALL: {
        PERMISSION: "/permission/all",
        ROLE: "/role/all",
        TYPE: "/type/all",
        PRODUCT: "/product/all"
    },
    PUBLIC: {
        LOGIN: "/public/login",
        VERIFY: "/public/verify",
        INDEX: "/index",
        PASSWORD_UPDATE: "/passwordUpdate",
    },
}

// 创建 axios 实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // 请求的基础路径，可根据实际情况修改
    timeout: 5000 // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 添加登录Token
        if (localStorage.getItem("AUTH-ADMIN")) {
			config.headers["AUTH-ADMIN"] = localStorage.getItem("AUTH-ADMIN");
		}
        return config;
    },
    error => {
        // 处理请求错误
        console.log(error); 
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data;
        // 根据实际业务需求处理响应数据
        return res;
    },
    error => {
        if (error.status == 401) {
            Message.error("尚未登录！");
            router.push("/login");
        }
        else if (error.status == 500) {
            Message.error("服务端出错！");
        }
    }
);

service.defaults.withCredentials = true;


async function doGet(url, params = {}) {
    return service.get(url, { params });
}

async function doPost(url, params = {}) {
    return service.post(url, params);
}

async function doPut(url, params = {}) {
    return service.put(url, params);
}

async function doPatch(url, params = {}) {
    return service.patch(url, params);
}

async function doDelete(url, id) {
    return service.delete(url + '/' + id);
}

export {
    API,
    doGet,
    doPost,
    doPut,
    doPatch,
    doDelete
}